<template>
	<div class="put-option-setting">
		<div class="position_center md-layout-item" style="max-width:920px;">

			<div v-if="displayNotAcceptedInfo" class="light_bg_color">
				<p class="light_bg_color" >
					{{ $t("company.putOptionSetting.putOptionBeforeAcceptance") }}
					<br/><br/>
					<span v-html="putOptionContractHint"></span>
				</p>
			</div>

			<div v-if="displayAppliedInfo" class="light_bg_color">
				<h4 class="font_lg font_bold margin_title_bottom">
					<i class="fa fa-check valid_color" aria-hidden="true"></i>
					{{ $t("company.putOptionSetting.agbAccepted") }}
				</h4>
				<p class="text_justify light_bg_color" >
					{{ $t("company.putOptionSetting.putOptionApplied") }}
					<br/><br/>
					<span v-html="putOptionContractHint"></span>
				</p>
			</div>

			<div v-if="displayApprovedInfo" class="light_bg_color">
				<h4 class="font_lg font_bold margin_title_bottom">
					<i class="fa fa-check valid_color" aria-hidden="true"></i>
					{{ $t("company.putOptionSetting.agbAccepted") }}
				</h4>
				<p class="text_justify" >
					{{ $t("company.putOptionSetting.putOptionApproved") }}
					<br/><br/>
					<span v-html="putOptionContractHint"></span>
				</p>
			</div>

			<h4 class="font_lg font_bold margin_top">
				{{ $t("company.putOptionSetting.title") }}
			</h4>

			<p class="text_justify">
				{{ $t("company.putOptionSetting.summary") }}
			</p>

			<p class="font_bold sub-title">
				{{ $t("company.putOptionSetting.preamble.title") }}
			</p>
			<p class="text_justify">
				{{ $t("company.putOptionSetting.preamble.text") }}
			</p>

			<p class="font_bold text_left sub-title">
				{{ $t("company.putOptionSetting.paragraph1.subTitle") }}
			</p>
			<ul class="text_justify tip_list">
				<li v-for="n in 6" :key="n">
					{{ $t(`company.putOptionSetting.paragraph1.list${n}`) }}
				</li>
			</ul>

			<p class="font_bold text_left sub-title">
				{{ $t("company.putOptionSetting.paragraph2.subTitle") }}
			</p>
			<ul class="text_justify tip_list">
				<li v-for="n in 6" :key="n">
					{{ $t(`company.putOptionSetting.paragraph2.list${n}`) }}
				</li>
			</ul>
			<template v-for="n in [ 3, 4, 5, 6, 7]" >
				<p class="font_bold text_left sub-title">
					{{ $t(`company.putOptionSetting.paragraph${n}.subTitle`)}}
				</p>
				<p class="text_justify">
					{{ $t(`company.putOptionSetting.paragraph${n}.text`)}}
				</p>
			</template>

			<div v-if="displayAcceptButton" class="flex flex_center" style="width:520px;margin:20px auto;">
				<md-button class="opacity_5 md-primary" @click="confirmSubmit">
					{{ $t("common.button.accept") }}
				</md-button>
			</div>
		</div>
	</div>
</template>
<script>
import {companyProfileApi} from "@/common/api/companyProfileApi";
import {localization} from "@/common/lang/localization";

export default {
	data() {
		return {
			defaultForm: {
				putOptionTradingApplied: false,
				putOptionBuyEnabled: false
			},
			form : {...this.defaultForm},
			contractLocales: ["de", "en"]
		}
	},
	methods: {
		confirmSubmit() {
			let option = {
				title: "",
				msg: this.$t("company.putOptionSetting.submit.confirm.text"),
				confirmFun: this.submit
			};
			this.confirmMeg(option, true);
		},
		submit() {
			companyProfileApi.operation.applyPutOptionTrading()
			.then(() => {
				this.form.putOptionTradingApplied = true;
				this.toastSuccess(this.$t("company.putOptionSetting.submit.success"));
			}).catch(this.toast);
		},
		loadPutOptionSetting() {
			companyProfileApi.inspection.getPutOptionSettingStatus()
			.then(res => {
				this.form = {...res}
			}).catch(this.toast);
		}
	},
	computed: {
		putOptionContractUrl() {
			let locale = localization.currentLocale();
			if (!this.contractLocales.includes(locale)) {
				locale = "en"
			}

			return "/vue/pdf/putoption/put_option_contract_sample_" + locale + ".pdf"
		},
		putOptionContractHint() {
			return this.$t("company.putOptionSetting.putOptionContractHint", {
				url: this.putOptionContractUrl
			})
		},
		displayAcceptButton() {
			return !this.form.putOptionTradingApplied && !this.form.putOptionBuyEnabled;
		},
		displayNotAcceptedInfo() {
			return !this.form.putOptionTradingApplied && !this.form.putOptionBuyEnabled;
		},
		displayAppliedInfo() {
			return this.form.putOptionTradingApplied && !this.form.putOptionBuyEnabled;
		},
		displayApprovedInfo() {
			return this.form.putOptionBuyEnabled;
		}
	},
	beforeMount() {
		this.form = {...this.defaultForm}
		this.loadPutOptionSetting();
	}

}
</script>

<style lang="scss">
.put-option-setting {
	.sub-title {
		margin-top: 28px;
	}
	.tip_list {
		list-style: circle;
		padding: 0 0 0 16px;
		li {
			margin: 0 0 8px 0;
		}
		i {
			padding-right: 12px;
		}
	}
}
</style>